import { Paths, PathValue } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKMaalingAvArbeidstrykkOgKontrollAvInternTrykkmaalerResultater,
  IGKRapport,
} from "../../../../../../mc-shared/reportSchemas/gkReportSchema";
import { beregnetDiffMellomToVerdier } from "../gkGlobalUtils";
const MaalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvArbeidstrykkOgKontrollAvInternTrykkmaalerResultater;
}> = ({ data, onUpdateEditData }) => {
  useEffect(() => {
    utdataBeregninger();
  }, [
    data.inndata.avlestTrykkHovedkammer,
    data.inndata.maaltInterntrykkHoeyreSluse,
    data.inndata.maaltInterntrykkHoeyreSluse,
    data.inndata.avlestInterntrykkHoeyreSluse,
    data.inndata.maaltInterntrykkVenstreSluse,
    data.inndata.avlestInterntrykkVenstreSluse,
  ]);
  const utdataBeregninger = () => {
    const trykkDiffHovedkammer = beregnetDiffMellomToVerdier(
      data.inndata.maaltTrykkHovedkammer,
      data.inndata.avlestTrykkHovedkammer,
    );
    const trykkDiffHoeyreSluse = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkHoeyreSluse,
      data.inndata.avlestInterntrykkHoeyreSluse,
    );
    const trykkDiffVenstreSluse = beregnetDiffMellomToVerdier(
      data.inndata.maaltInterntrykkVenstreSluse,
      data.inndata.avlestInterntrykkVenstreSluse,
    );
    const utdata = {
      trykkDiffHovedkammer: trykkDiffHovedkammer,
      trykkDiffHoeyreSluse: trykkDiffHoeyreSluse,
      trykkDiffVenstreSluse: trykkDiffVenstreSluse,
    };
    onUpdateEditData("testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Måling av interntrykk og kontroll av intern trykkmåler</Title>
        <div>
          <div className="d-flex flex-column mt-4">
            <h5 className="mb-0">Hovedkammer:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestTrykkHovedkammer}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.avlestTrykkHovedkammer",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltTrykkHovedkammer}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.maaltTrykkHovedkammer",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestTrykkHovedkammer,
                  data.inndata.maaltTrykkHovedkammer,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <div className="d-flex flex-column mt-0">
            <h5 className="mb-0">Høyre sluse:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkHoeyreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.avlestInterntrykkHoeyreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkHoeyreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.maaltInterntrykkHoeyreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkHoeyreSluse,
                  data.inndata.maaltInterntrykkHoeyreSluse,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <div className="d-flex flex-column mt-0">
            <h5 className="mb-0">Venstre sluse:</h5>
            <McInputNew
              label="Fyll inn avlest trykk (Pa):"
              value={data.inndata.avlestInterntrykkVenstreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.avlestInterntrykkVenstreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex flex-column mt-2">
            <McInputNew
              label="Fyll inn målt trykk (Pa):"
              value={data.inndata.maaltInterntrykkVenstreSluse}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) =>
                onUpdateEditData(
                  "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.maaltInterntrykkVenstreSluse",
                  Number(e.target.value),
                )
              }
              className="w-25"
            />
          </div>
          <div className="d-flex justify-content-between">
            <p className="mb-0">
              Trykkdifferanse &#40;Pa&#41; =
              <b>
                {" "}
                {beregnetDiffMellomToVerdier(
                  data.inndata.avlestInterntrykkVenstreSluse,
                  data.inndata.maaltInterntrykkVenstreSluse,
                )?.toFixed(2) ?? ""}
              </b>
            </p>
            <p className="mb-0">Formel: &#40;Pd = Pm - Pa&#41;</p>
          </div>
        </div>
        <hr className="mt-0" />
        <div>
          <h5 className="mb-0">I henhold til fabrikantens spesifikasjoner?</h5>
          <div className="d-flex flex-column">
                        <Radio
              checked={data.inndata.ihenholdTilFabrikant === true}
              onChange={() =>
              onUpdateEditData(
              "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.ihenholdTilFabrikant",
              true,
              )
              }
              label="Godkjent"
            />
                        <Radio
              checked={data.inndata.ihenholdTilFabrikant === false}
              onChange={() =>
              onUpdateEditData(
              "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.ihenholdTilFabrikant",
              false,
              )
              }
              label="Ikke godkjent"
            />
          </div>
        </div>
        <div className="w-50 mt-4">
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData(
                "testResultater.maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler.inndata.kommentar",
                e.target.value,
              )
            }
          />
        </div>
      </Stack>
    </Paper>
  );
};
export default MaalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler;